var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import StoreNotification from '../stores/StoreNotification';
import { Notification } from '../components/notification';
import genericResolveProps from './genericResolveAction';
var store = new StoreNotification();
export var notification = function (_a) {
    var _b = _a.duration, duration = _b === void 0 ? 7000 : _b, _c = _a.position, position = _c === void 0 ? 'topRight' : _c, _d = _a.type, type = _d === void 0 ? 'success' : _d, _e = _a.closable, closable = _e === void 0 ? false : _e, props = __rest(_a, ["duration", "position", "type", "closable"]);
    var resolveProps = genericResolveProps(__assign({ type: type }, props), Notification, 'notification');
    store.subscribe(__assign({ duration: duration, position: position, closable: closable }, resolveProps));
};
